import React, { useContext } from 'react';

import { Pagination } from 'src/components/Pagination/Pagination';
import { PrevLink } from 'src/components/Pagination/PrevLink';
import { Items } from 'src/components/Pagination/Items';
import { NextLink } from 'src/components/Pagination/NextLink';

import { SkeletonItemList } from '../Helpers/SkeletonItemList';

import { ProductList } from './ProductList';
import { ProductListQueryContext } from './ProductListQueryProvider';

type Props = {
    title: string;
    urlKey: string;
};

export function ProductListWrapper(props: Props) {
    const { pageInfo, loading, products, createPageUrl } = useContext(ProductListQueryContext);

    // no data yet, loading = show skeleton
    if (loading && products.length === 0) {
        return <SkeletonItemList qty={6} />;
    }

    // NOT loading, but products array is empty
    if (!loading && products.length === 0) {
        return <p>No products found</p>;
    }

    // Products array is NOT empty, but might be loading
    if (products.length > 0) {
        const { total_pages, current_page } = pageInfo;
        return (
            <>
                <ProductList products={products} loading={loading} listName={props.title} listId={props.urlKey} />
                {total_pages > 1 && (
                    <Pagination>
                        <PrevLink currentPage={current_page} createUrl={createPageUrl} />
                        <Items createURL={createPageUrl} totalPages={total_pages} currentPage={current_page} />
                        <NextLink currentPage={current_page} totalPages={total_pages} createUrl={createPageUrl} />
                    </Pagination>
                )}
            </>
        );
    }

    return <p>Unknown...</p>;
}
